import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../../config/Helpers";

export default function useOfferDetails(id) {
    return useQuery({
        queryKey: ["slice-offer-details", id],
        queryFn: async () => {
            const { data } = await axiosInstance.get(
                `affiliate-program/slice/offer/${id}`
            );
            return data;
        },
    });
}
